import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    delay?: string;
}

export const GlassCard: React.FC<CardProps> = ({ children, className = "", delay = "" }) => (
    <div className={`glass-card reveal ${delay} ${className}`}>
        {children}
    </div>
);

